import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { postFormData, getData } from '../../services/RequestWrapper';


function FamilyInvite() {
	const [loading, setLoading] = useState(false);
	const [invite, setInvite] = useState(null);
	const [responded, setResponded] = useState(false);

	useEffect(() => {
		fetchInvite();
	}, []);

	const fetchInvite = async () => {
		setLoading(true);
		const data = await getData('/api/settings/family/get/invite');
		setInvite(data);
		setLoading(false);
	};

	const handleRespond = async (answer) => {
		postFormData('/api/settings/family/invite/respond', { responce: answer }).then(data => {
			setLoading(false);
			if (data.status === 0) setResponded(true);
			if (data.status === 1) alert(data.message);
		});		
	};

	if (loading) return <div>Loading...</div>;
	if (responded) return <div>Сміливий крок 👏</div>;

	return (
		<div>
			{(invite != null && invite.inviteStatus === 1) && (
				<>
					<h3>У Вас нова пропозиція</h3>

					<div>
						<Card>
							<Card.Body>
								<div className="d-flex align-items-center">
									<img
										src={invite.ownerAvatar || '/default-user.png'}
										alt={invite.ownerName}
										style={{ width: 40, height: 40, borderRadius: '50%', marginRight: 12 }}
									/>
									<span>{invite.ownerName} запропонував створити сім'ю </span>
								</div>
								<br />

								<Button variant="success" className="me-2" onClick={() => handleRespond(0)}>
									Погодитись, але показати тільки статистику 🤝
								</Button> 
								<br /><br />
								<Button variant="warning" className="me-2" onClick={() => handleRespond(1)}>
									Погодитись і показати всю історію транзакцій 💖
								</Button>
								<br /><br />
								<Button variant="outline-danger" onClick={() => handleRespond(-1)}>
									Мені дуже шкода, але я не можу прийняти пропозицію 🎃
								</Button>
							</Card.Body>
						</Card>
						<br /><br />
					</div>
				</>
			)}
		</div>
	);
}

export default FamilyInvite;